import { InputNumber } from 'antd';

const PercentageInput = ({ value, onChange, allowNegative = false, ...props }) => {
  return (
    <InputNumber
      value={value}
      onChange={onChange}
      suffix="%"
      min={allowNegative ? undefined : 0}
      max={100}
      step={0.8}
      precision={2}
      decimalSeparator={','}
      {...props}
    />
  );
};
// const PercentageInput = ({ value, onChange, ...props }) => {
//   const [tempValue, setTempValue] = useState(value);

//   useEffect(() => {
//     setTempValue(value);
//   }, [value]);

//   const handlePressEnter = () => {
//     onChange?.(tempValue);
//   };

//   return (
//     <InputNumber
//       value={tempValue}
//       onChange={setTempValue}
//       onPressEnter={handlePressEnter}
//       onBlur={handlePressEnter}
//       min={0}
//       max={99999999999}
//       step={0.1}
//       precision={2}
//       suffix="%"
//       decimalSeparator=","
//       {...props}
//     />
//   );
// };


export default PercentageInput;